import React from 'react';
import { Col, Row, Layout, Divider } from 'antd';

const headerStyle: React.CSSProperties = {
    color: '#090909ff',
    lineHeight: '25px',
    backgroundColor: '#fff',
    paddingLeft: '0px',
    paddingRight: '0px',
};
const dividerStyle: React.CSSProperties = {
    margin: '15px',
};

interface PriceCardViewData {
    groupName: string[];
    priceItems: Array<{ priceUsd?: number | string }>;
}

/**
 * 业务类型（TT：CBT/FBT）定价卡片组件
 */
const PriceCard: React.FC<{
    cardViewData: PriceCardViewData;
}> = ({ cardViewData }) => {
    const { Header, Sider, Content } = Layout;
    const price = cardViewData.priceItems?.[0]?.priceUsd;
    return (
        <Layout style={{ backgroundColor: '#fff', padding: 15, border: '1px solid #e8e8e8', borderRadius: 5 }}>
            <Header style={headerStyle}>
                <Row justify="center" align="middle">
                    <Col span={18}>
                        <span>业务类型</span>
                    </Col>
                    <Col span={6}>
                        <span>Price/价格</span>
                    </Col>
                </Row>
                <Divider style={dividerStyle} />
            </Header>
            <Layout>
                <Sider width="70%" theme="light" style={{ overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Row justify="center">
                        <Col style={{ width: '100%' }}>
                            <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
                                {cardViewData.groupName.map((name, index) => (
                                    <div key={index}>
                                        <p>{name}</p>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Sider>
                <Content style={{ background: '#fff' }}>
                    <Row justify="center" align="middle" style={{ height: '100%' }}>
                        <Col>
                            <span>{price ?? ''}</span>{' '}美金
                        </Col>
                    </Row>
                </Content>
            </Layout>
        </Layout>
    );
};

/**
 * 业务类型（TT）Tabb 只读展示组件：取件费（TT）/ 卸车费（TT）用
 */
const BizTypeFeeViewTab: React.FC<{ renderData: any }> = ({ renderData }) => {
    const cards: PriceCardViewData[] = React.useMemo(() => {
        if (!renderData || !Array.isArray(renderData)) {
            return [];
        }
        try {
            return renderData.map((item: any) => ({
                groupName: item.groupName || [],
                priceItems: Array.isArray(item.priceItems) ? item.priceItems : [],
            }));
        } catch (error) {
            console.error('Error converting renderData:', error);
            return [];
        }
    }, [renderData]);

    return (
        <div>
            {cards.map((card, index) => (
                <div key={index} style={{ marginBottom: index !== cards.length - 1 ? 15 : 0 }}>
                    <PriceCard cardViewData={card} />
                </div>
            ))}
        </div>
    );
};

export default BizTypeFeeViewTab;
